// extracted by mini-css-extract-plugin
module.exports = {"list":"Numbers_style_list__c9YjT","item":"Numbers_style_item__2XfUo","value":"Numbers_style_value__2W6J_","title":"Numbers_style_title__tE7h1"};